// src/htmlFormatterUtils.js
export const formatHtml = (html, tabSize = 2) => {
    try {
        // Void elements never have a closing tag
        const VOID = new Set(['area','base','br','col','embed','hr','img','input','link','meta','param','source','track','wbr']);
        // Raw-text elements — preserve their inner content exactly
        const RAW = new Set(['pre','script','style','textarea']);

        const tab = ' '.repeat(tabSize);

        let result = '';
        let indent = 0;
        let rawTag = ''; // set when inside a RAW element

        // Tokenise into tags and text nodes.
        // <!DOCTYPE ...> is included explicitly because <! is not matched by <\/?[a-zA-Z].
        const tokenRegex = /(<!DOCTYPE[^>]*>|<!--[\s\S]*?-->|<\/?[a-zA-Z][^>]*?>|[^<]+)/gi;
        let match;

        while ((match = tokenRegex.exec(html)) !== null) {
            const token = match[0];

            // Inside a raw element — output verbatim until its closing tag
            if (rawTag) {
                if (token.toLowerCase() === `</${rawTag}>`) {
                    // Put the closing tag on its own properly-indented line
                    if (!result.endsWith('\n')) result += '\n';
                    result += tab.repeat(indent) + token.trim() + '\n';
                    rawTag = '';
                } else {
                    result += token;
                }
                continue;
            }

            if (token.startsWith('<!')) {
                // DOCTYPE or similar declaration — output as-is at current indent, no indent change
                result += tab.repeat(indent) + token.trim() + '\n';
                continue;
            }

            if (token.startsWith('<!--')) {
                result += tab.repeat(indent) + token.trim() + '\n';
                continue;
            }

            if (token.startsWith('</')) {
                const tagName = (token.match(/^<\/([a-zA-Z][a-zA-Z0-9-]*)/) || [])[1]?.toLowerCase() || '';
                if (!VOID.has(tagName)) indent = Math.max(indent - 1, 0);
                result += tab.repeat(indent) + token.trim() + '\n';
                continue;
            }

            if (token.startsWith('<')) {
                const tagName = (token.match(/^<([a-zA-Z][a-zA-Z0-9-]*)/) || [])[1]?.toLowerCase() || '';
                const isSelfClosing = token.endsWith('/>') || VOID.has(tagName);
                result += tab.repeat(indent) + token.trim() + '\n';
                if (!isSelfClosing) {
                    if (RAW.has(tagName)) {
                        rawTag = tagName; // preserve content of next tokens verbatim
                    } else {
                        indent++;
                    }
                }
                continue;
            }

            // Plain text node
            const text = token.trim();
            if (text) result += tab.repeat(indent) + text + '\n';
        }

        return result.trim();
    } catch (error) {
        return "Invalid HTML";
    }
};
  